module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-square-lock-cdd5055a2698629f2fdfbd2b8f54202b.png";